import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const OptionBoxWrapper = styled.div`
  flex: initial !important;
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-bottom: -20px;
`;

export const ToggleOptionsButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  position: relative;
  ${media.md`
    width: initial;
  `}
`;
export const ControlsBox = styled.div<{ isOpen: boolean; descriptionHeight: number }>`
  overflow: visible;
  max-height: 0px;
  width: 100%;
  transition: 0.5s;

  ${({ isOpen, descriptionHeight }) =>
    isOpen &&
    `
    max-height: ${descriptionHeight}px;
  `}
`;

export const ControlsWrapper = styled.div<{ isOpen: boolean }>`
  padding: 20px 0;
  border-top: 1px solid #efefef;
  opacity: 0;
  transition: 0.5s;
  transition-delay: 0s;

  ${({ isOpen }) =>
    isOpen &&
    `
    opacity: 1;
    transition-delay: 0.3s;
  `}
`;
